import { Node } from "../node.js";
/**
 * @public
 */
export class Inert extends Node {
    static of(owner) {
        return new Inert(owner);
    }
    constructor(owner) {
        super(owner, [], "inert");
    }
    clone() {
        return new Inert(this._node);
    }
    isIgnored() {
        return true;
    }
    toString() {
        return "ignored";
    }
    toJSON() {
        const result = super.toJSON();
        delete result.children;
        return result;
    }
}
//# sourceMappingURL=inert.js.map